/* eslint-disable @next/next/no-img-element */
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { stringHasValue } from '@/utils/data';
import { ContentfulDocument } from '../Contentful/ContentfulDocument';
import { type Options } from '@contentful/rich-text-react-renderer';

export default function Banners({ banner }: { banner?: Banner }) {
  const getContentfulDocumentOptions = (banner: Banner): Options => {
    return {
      renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => (
          <span className='p' style={{ color: banner.bannerTextColour?.value }}>
            {children}
          </span>
        )
      },
      renderMark: {
        [MARKS.BOLD]: (text) => (
          <span
            className='highlight'
            style={{ color: banner.bannerTextHighlightColour?.value }}
          >
            {text}
          </span>
        )
      }
    };
  };

  if (!banner) return null;

  return (
    <>
      <div
        className='banner'
        key={banner.id}
        id={banner.id}
        style={{
          backgroundColor: banner.backgroundColour?.value,
          color: banner.bannerTextColour?.value
        }}
      >
        <div className='banner-wrapper'>
          {banner.logoDesktop?.file ? (
            <div className='banner-logo desktop-only'>
              <img
                src={banner.logoDesktop.file.url}
                alt={
                  banner.logoDesktop.title &&
                  stringHasValue(banner.logoDesktop.title)
                    ? banner.logoDesktop.title
                    : ''
                }
                className='banner-logo--img'
              />
            </div>
          ) : null}

          {banner.logoMobile?.file ? (
            <div className='banner-logo mobile-only'>
              <img
                src={banner.logoMobile.file.url}
                alt={
                  banner.logoMobile.title &&
                  stringHasValue(banner.logoMobile.title)
                    ? banner.logoMobile.title
                    : ''
                }
                className='banner-logo--img'
              />
            </div>
          ) : null}

          <div
            className='banner-content'
            style={{
              fontFamily:
                banner.bannerContentFont == 'Oswald'
                  ? 'Oswald-Regular'
                  : banner.bannerContentFont == 'Panton'
                    ? 'Panton-Regular'
                    : undefined,
              fontSize: banner.bannerContentFontSize
                ? `${banner.bannerContentFontSize}px`
                : undefined
            }}
          >
            <div className='banner-content--text desktop-only'>
              <ContentfulDocument
                document={banner.bannerContentDesktop}
                options={getContentfulDocumentOptions(banner)}
              />
            </div>
            <div className='banner-content--text mobile-only'>
              <ContentfulDocument
                document={banner.bannerContentMobile}
                options={getContentfulDocumentOptions(banner)}
              />
            </div>
          </div>

          {banner.buttonLink && stringHasValue(banner.buttonLink) ? (
            <div className='banner-button'>
              {banner.buttonLabelDesktop &&
              stringHasValue(banner.buttonLabelDesktop) ? (
                <a
                  className='theme-btn banner-button--link desktop-only'
                  href={banner.buttonLink}
                  target='blank'
                  style={{
                    backgroundColor: banner.buttonBackgroundColour?.value,
                    borderColor: banner.buttonBackgroundColour?.value,
                    color: banner.buttonLabelColour?.value
                  }}
                >
                  {banner.buttonLabelDesktop}
                </a>
              ) : null}

              {banner.buttonLabelMobile &&
              stringHasValue(banner.buttonLabelMobile) ? (
                <a
                  className='theme-btn banner-button--link mobile-only'
                  href={banner.buttonLink}
                  target='blank'
                  style={{
                    backgroundColor: banner.buttonBackgroundColour?.value,
                    borderColor: banner.buttonBackgroundColour?.value,
                    color: banner.buttonLabelColour?.value
                  }}
                >
                  {banner.buttonLabelMobile}
                </a>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
